import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { InstanceService } from '../services/instance.service';
import * as InstanceActions from '../actions/instance.actions';

@Injectable()
export class InstanceEffects {
  loadInstances$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstanceActions.loadInstances),
      exhaustMap(() => {
        return this.instanceService.getInstances().pipe(
          map((instances: any) => {
            return InstanceActions.loadInstancesSuccess({ instances });
          }),
          catchError(() => of(InstanceActions.failedLoadingInstances()))
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private instanceService: InstanceService
  ) {}
}
